<template>

    <div>
  
  
      <!-- Table Container Card -->
      <b-card
        no-body
        class="mb-0"
      >
  
        <div class="m-2">
  
          <!-- Table Top -->
          <b-row>
  
            <!-- Per Page -->
            <b-col
              cols="12"
              md="4"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>Gösterim Sayısı</label>
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
              />
              <label>sonuç</label>
            </b-col>
            <b-col :md="4" v-if="title">
                <b-card-title class="justify-content-center mb-0 text-center">
                {{ title }}
                </b-card-title>
            </b-col>
  
          </b-row>
  
        </div>
  
        <b-table
          ref="refUserListTable"
          class="position-relative"
          :items="eventHourlyData"
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="Sonuç bulunamadı"
          :sort-desc.sync="isSortDirDesc"
        >
        
        <template #cell(influencer)="data">
          <template v-if="data.item.influencer && data.item.influencer.id">
            <influencer-link-btn :id="data.item.influencer.id" :name="data.item.influencer.username" />
          </template>
          <template v-else>
            <p>Bilinmeyen Fenomen</p>
          </template>
        </template>
        
  
        <template #cell(link)="data">
          <template v-if="data.item.link && data.item.link.id">
            <campaign-link-btn :id="data.item.link.id" :name="data.item.link.campaign_name" />
          </template>
          <template v-else>
            <p>Bilinmeyen Paylaşım</p>
          </template>
        </template>
  
  
        <template #cell(total_vat)="data">
              {{ data.item.total_vat }} {{ data.item.store_currency }}
        </template>
  
        <template #cell(show_details)="data">
  
        <!-- As `data.showDetails` is one-way, we call the toggleDetails function on @change -->
        <div @click="data.toggleDetails" style="cursor: pointer;">
          <FeatherIcon icon="ChevronUpIcon" v-if="data.detailsShowing"></FeatherIcon>
          <FeatherIcon icon="ChevronDownIcon" v-else></FeatherIcon>
          Saatlik Bilgi
        </div>
        
        </template>
  
        <template #cell(page_url)="data">
              <a :href="data.item.page_url" target="_blank">     
                 {{ data.item.page_url.length > 50 ? data.item.page_url.substring(0, 50) + "..." : data.item.page_url }}
              </a>
          </template>
  
        <template #cell(date)="data">
          {{ formatDate(data.item.date) }}
        </template>

        <template #cell(time)="data">
            {{ formatTimeRange(data.item.date, data.item.time) }}
        </template>
  
  
        <!-- full detail on click -->
        <template #row-details="data">
          test
        </template>
  
        </b-table>
        <div class="mx-2 mb-2">
            <b-row>

            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
                <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
            </b-col>
            <!-- Pagination -->
            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >

                <b-pagination
                v-model="currentPage"
                :total-rows="totalEvents"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
                >
                <template #prev-text>
                    <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                    />
                </template>
                <template #next-text>
                    <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                    />
                </template>
                </b-pagination>

            </b-col>

            </b-row>
        </div>
      </b-card>
  
    </div>
  </template>
  
  <script>
  import {
    BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
    BBadge, BDropdown, BDropdownItem, BPagination, BFormCheckbox, BTableLite,
    BCardTitle
  } from 'bootstrap-vue'
  import vSelect from 'vue-select'
  import store from '@/store'
  import { ref, onUnmounted , watch} from '@vue/composition-api'
  import { avatarText } from '@core/utils/filter'
  import CampaignLinkBtn from '@/components/link/CampaignLinkBtn.vue'
  import useEventsHourly from '@/components/event/useEventsListHourly'
  import InfluencerLinkBtn from '@/components/link/InfluencerLinkBtn.vue'
import { required } from 'vee-validate/dist/rules'
  
  export default {
    components: {
      
      BCard,
      BRow,
      BCol,
      BFormInput,
      BButton,
      BTable,
      BMedia,
      BAvatar,
      BLink,
      BBadge,
      BCardTitle,
      BDropdown,
      BDropdownItem,
      BPagination,
      BFormCheckbox,
      BTableLite,
  
      vSelect,
      CampaignLinkBtn,
      InfluencerLinkBtn
    },
    props: {
        link_id: {
            type: Number,
            required:true
        },
        title: {
            type: String,
            default: () => ('') // Boş bir nesne
        },
    },

    methods: {
        formatTimeRange(date, time) {
            if (!date || !time) return "";

            // Tarih ve saat bilgilerini birleştirip Date nesnesi oluştur
            const dateTime = new Date(`${date}T${time}`);

            // Eğer geçerli bir tarih değilse hata döndür
            if (isNaN(dateTime.getTime())) return "Geçersiz tarih";

            // Bir saat sonrasını hesapla
            const nextHour = new Date(dateTime);
            nextHour.setHours(nextHour.getHours() + 1);

            // Yerel saat dilimiyle formatla (HH:MM)
            const format = (d) =>
                d.toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit" });

            return `${format(dateTime)} - ${format(nextHour)}`;
        }
    },

    setup(props) {
  
        const {
            eventHourlyData,
            tableColumns,
            perPage,
            currentPage,
            totalEvents,
            dataMeta,
            perPageOptions,
            searchQuery,
            sortBy,
            isSortDirDesc,
            refUserListTable,
            refetchData,
            additionalParams,
    
            // UI
            resolveUserRoleVariant,
            resolveUserRoleIcon,
            resolveEventstatusVariant,
    
        } = useEventsHourly()
  

        additionalParams.value = { 'id': props.link_id };
    
        watch(() => props.params, async (newParams) => {
            additionalParams.value = { ...newParams };  
        }, { deep: true });
        
      return {
  
  
        eventHourlyData,
        tableColumns,
        perPage,
        currentPage,
        totalEvents,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refUserListTable,
        refetchData,
  
        // Filter
        avatarText,
  
        // UI
        resolveUserRoleVariant,
        resolveUserRoleIcon,
        resolveEventstatusVariant,
  
      }
    },
  }
  </script>
  
  <style lang="scss" scoped>
  .per-page-selector {
    width: 90px;
  }
  </style>
  
  <style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  </style>
  